import React from 'react';
import { FormattedMessage } from 'react-intl';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Image } from '@daedalus/atlas/Image';
import placeHolderImage from '@daedalus/atlas/images/placeholder-hotel-image.svg';
import { PriceComposition } from '@daedalus/atlas/PriceComposition';
import { StarRating } from '@daedalus/atlas/StarRating';
import { Text } from '@daedalus/atlas/Text';
import { hasAnchorPrice } from '@daedalus/core/src/offer/business/price';
import { ImageProvider } from '@daedalus/core/src/staticContent/types/ImageProvider';
import { getRoundingStrategy, RoundingStrategy } from '@daedalus/core/src/utils/number';
import { ReviewRating } from '../ReviewRating';
import { PriceDetailsSkeleton } from './SuggestionHotelCardSkeleton';
const ClickArea = /*#__PURE__*/styled('div')({
  name: "ClickArea",
  class: "ctofj67",
  propsAsIs: false
});
const TopSection = /*#__PURE__*/styled('section')({
  name: "TopSection",
  class: "t1ul67da",
  propsAsIs: false
});
const GalleryAndDetailsComponentWrapper = /*#__PURE__*/styled('div')({
  name: "GalleryAndDetailsComponentWrapper",
  class: "g1k3p7ow",
  propsAsIs: false
});
const BottomSection = /*#__PURE__*/styled('section')({
  name: "BottomSection",
  class: "b1a4bubx",
  propsAsIs: false
});
const GalleryComponentWrapper = /*#__PURE__*/styled('div')({
  name: "GalleryComponentWrapper",
  class: "gov57cj",
  propsAsIs: false
});
const PropertyDetailsComponentWrapper = /*#__PURE__*/styled('div')({
  name: "PropertyDetailsComponentWrapper",
  class: "pk62f24",
  propsAsIs: false
});
const PropertyNameAndRating = /*#__PURE__*/styled('div')({
  name: "PropertyNameAndRating",
  class: "p1bd8onn",
  propsAsIs: false
});
const NameAndRatingWrapper = /*#__PURE__*/styled('div')({
  name: "NameAndRatingWrapper",
  class: "n1nrsimj",
  propsAsIs: false
});
const _exp12 = /*#__PURE__*/() => Text;
const HotelName = /*#__PURE__*/styled(_exp12())({
  name: "HotelName",
  class: "hj201p6",
  propsAsIs: true
});
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wz8c99c",
  propsAsIs: false
});
const PriceWrapper = /*#__PURE__*/styled('div')({
  name: "PriceWrapper",
  class: "ppd6unw",
  propsAsIs: false
});
interface Props {
  hotelName: string;
  starRating?: number;
  reviewRating?: number;
  reviewRatingCount?: number;
  imageUrl?: string;
  price: number;
  anchorPrice?: number;
  currency: string;
  roundingStrategy?: RoundingStrategy;
  imageProvider: ImageProvider;
  onHotelClick?: (event: React.MouseEvent) => void;
  offerDDActionName?: string;
  isPrivateDeal?: boolean;
  hasInsideMargin?: boolean;
}
export const SuggestionHotelCard = ({
  hotelName,
  starRating,
  reviewRating,
  reviewRatingCount,
  imageUrl,
  currency,
  price,
  imageProvider,
  anchorPrice = 0,
  roundingStrategy = getRoundingStrategy(),
  onHotelClick,
  offerDDActionName,
  hasInsideMargin = false
}: Props) => <Wrapper data-dd-action-name={offerDDActionName} className={cx(hasInsideMargin && 'hasInsideMargin')}>
    <ClickArea role="button" tabIndex={0} onClick={onHotelClick}>
      <TopSection>
        <GalleryAndDetailsComponentWrapper>
          <GalleryComponentWrapper>
            {imageUrl && <Image imageProvider={imageProvider} url={imageUrl} isResponsive size="large" placeHolderImage={placeHolderImage} />}
          </GalleryComponentWrapper>
        </GalleryAndDetailsComponentWrapper>
      </TopSection>
      <BottomSection>
        <PropertyDetailsComponentWrapper>
          <PropertyNameAndRating>
            <NameAndRatingWrapper>
              {starRating && <StarRating rating={starRating} size="xs" />}
              <HotelName variant="labelM">{hotelName}</HotelName>
            </NameAndRatingWrapper>
            {reviewRating && <ReviewRating rating={reviewRating} totalRatingCount={reviewRatingCount} />}
          </PropertyNameAndRating>

          <PriceWrapper>
            <Text variant="bodyXS" colorPath="content.neutral.c600">
              <FormattedMessage id="SuggestionHotelCard.priceLabel" defaultMessage="Nightly from" />
            </Text>

            {price ? <PriceComposition size="xl" showLockIcon={false} showRowLayout showAnchorPrice={hasAnchorPrice(price, anchorPrice)} anchorPrice={anchorPrice} currencyCode={currency} price={price} roundingStrategy={roundingStrategy} /> : <PriceDetailsSkeleton />}
          </PriceWrapper>
        </PropertyDetailsComponentWrapper>
      </BottomSection>
    </ClickArea>
  </Wrapper>;

require("./SuggestionHotelCard.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SuggestionHotelCard.tsx");